import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PAYMENT METHODS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'paymentMethods' como el nombre del recurso a la clase base
    super('paymentMethods');
    log.debug('Servicio de Métodos de Pago inicializado');
  }

}
